import { useMutation } from '@tanstack/react-query';

import { axiosInstance, downloadBlobDataFile } from '~/services';

const ENDPOINT = '/api-lip/v1/third-parties/third-party-sku-excel-upload';

/**
 * [상품관리][상품 등록/수정] 상품 엑셀 일괄 등록 API
 *
 * @note 업로드한 엑셀 파일에 문제가 있으면 에러를 담고 있는 엑셀 파일이 반환됩니다.
 */
export const fetchPostThirdPartySkuExcelUpload = async (file: File) => {
  const response = await axiosInstance.post<null | Blob>(
    ENDPOINT,
    { file },
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    }
  );

  const isExcelData = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ].includes(response?.data?.type ?? '');

  if (isExcelData) {
    downloadBlobDataFile(response);
    throw new Error('업로드한 엑셀 파일에 문제가 있습니다.\n자세한 내용은 엑셀 파일을 확인해주세요.');
  }
};

/**
 * [상품관리][상품 등록/수정] 상품 엑셀 일괄 등록 Mutation Hook
 */
export const usePostThirdPartySkuExcelUploadMutation = () => {
  return useMutation({
    mutationFn: fetchPostThirdPartySkuExcelUpload,
  });
};
